module.exports = __webpack_public_path__ + "static/media/iStock-1170425284.11535a86.jpg";